import { Avatar, Tooltip } from "@mantine/core";

/** Zwei Initialen aus einem Anzeigenamen: „Armin Bittner" → „AB". */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function AssigneeBadge({ name }: { name?: string | null }) {
  if (!name) return null;
  return (
    <Tooltip label={name} withArrow>
      <Avatar size={20} radius="xl" color="orange">{initialsOf(name)}</Avatar>
    </Tooltip>
  );
}
